<template>
  <div id="app" v-if="(!errorMsg && !isLoading) || isDev || isPrintPage">
	  <!--   -->
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <transition name="intro" v-if="!isDev && !isPrintPage">

		<!--  -->
		<!-- <FlashPage v-if=" showFlashPage" :skipFlashPage="skipFlashPage"/> -->
      <IntroVideo v-if="showFlashPage" :skipFlashPage="skipFlashPage" />
    </transition>
  </div>

  <teleport to="body">
    <UiToastList />
    <UiModal />
    <LoadingScreen
	  v-if="!isDev && !isPrintPage"
      :isLoading="isLoading"
      :errorMsg="errorMsg"
    />
	<!-- v-if="!isDev && !isPrintPage" -->
	 <!--   -->

  </teleport>
</template>

<script>
// import AppHeader from "./Header.vue";
import AppFooter from "./Footer.vue";
import { PurlService } from "@/services/purl.service";
import UiToastList from "@/components/UiToastList";
import FlashPage from "@/components/FlashPage";
import UiModal from "@/components/UiModal";
import LoadingScreen from "@/components/LoadingScreen";
import IntroVideo from "@/components/IntroVideo";
import VueScrollTo from "vue-scrollto";

export default {
  name: "AppLayout",
  components: {
    // AppHeader,
    AppFooter,
    UiToastList,
    UiModal,
	FlashPage,
    LoadingScreen,
    IntroVideo,
  },
  data() {
    return {

      fetchParams: null,
      isLoading: true,
      showFlashPage: true,
      errorMsg: "",
      isDev: process.env.NODE_ENV === "development",
      isPrintPage: this.$router.currentRoute.value.name === "InvoicePrint",
    };
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      //* Initial purl fetch
      PurlService.getPurl(this.purlId)
        .then((purlInfo) => {
          this.$store.dispatch("purl/setPurlInfo", purlInfo);
          //* Initial browser tracking
          this.$store.dispatch("purl/purlTracking", "browser");
        })
        .catch((e) => {
          console.log("Error: ", e.message);
          this.errorMsg = e.message;
        })
        .finally(() => {
          setTimeout(() => {
            const hash = this.$router.currentRoute.value.hash;
            if (hash) {
              setTimeout(() => {
                VueScrollTo.scrollTo(hash);
              }, 200);
            }
            this.isLoading = false;
          }, 3000);
        });
    },
    skipFlashPage() {
      this.showFlashPage = false;
    },
  },
  computed: {
    purlId() {
      return this.$store.state.purl.id;
    },
  },
  watch: {
    purlId: function (value) {
      //* Check if the purl exist in the url
      value === "purlId not included"
        ? (this.errorMsg = "Purl is not included in the url.")
        : this.fetchData();
    },
  },
  beforeUnmount: () => {
    window.removeEventListener("resize", () =>
      this.$store.commit("dom/SET_WINDOW_WIDTH", window.innerWidth)
    );
  },
};
</script>
<style lang="scss">
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s;
}
.intro-enter-active,
.intro-leave-active {
  transition: opacity 0.8s;
}
.intro-enter,
.intro-leave-to {
  opacity: 0;
}
</style>
